<script lang="ts">
    import {createEventDispatcher, onMount} from "svelte";
    import FontAwesomeView from "../Image/FontAwesomeView.svelte";
    import PortalView from "../Portal/PortalView.svelte";

    const dispatcher = createEventDispatcher();

    let menuRowTextArray = [];
    export let portalTargetSelector = '#hamburger-menu-portal-target';

    let menuTop = null;
    let menuLeft = null;
    let menuRight = null;

    $: menuAreaStyle = (() => {
        const styleArray = [];

        if (menuTop != null) {
            styleArray.push(`top: ${menuTop}px;`);
        }
        if (menuLeft != null) {
            styleArray.push(`left: ${menuLeft}px;`);
        }
        if (menuRight != null) {
            styleArray.push(`right: ${menuRight}px;`);
        }

        const menuAreaStyle = styleArray.join(';');
        return menuAreaStyle;
    })();

    $: menuAreaClass = (() => {
        const classArray = [];
        classArray.push('menu-area');
        if (isOpen) {
            classArray.push('animation-fade-in-down');
        }

        const menuAreaClass = classArray.join(' ');
        return menuAreaClass;
    })();

    let isOpen = false;
    let rootElement = null;

    onMount(() => {
    });

    function onClick() {
        isOpen = !isOpen;

        if (isOpen) {
            // 開く場合

            // メニューの場所を設定
            const windowWidth = window.innerWidth;
            const rect = rootElement.getBoundingClientRect();
            console.log({rect});

            menuRight = windowWidth - (rect.left + rect.height);
            menuTop = rect.top + rect.height + 1;

        }
    }

    function onClickMenuBackground() {
        isOpen = false;
    }

    function onClickRow(menuRowText) {
        dispatcher('clickRow', {
            menuRowText: menuRowText,
        });
    }

</script>

<div class="hamburger-menu-view" on:click={onClick}
     bind:this={rootElement}
>
    <FontAwesomeView icon="bars"/>
</div>


<PortalView portalTargetSelector={portalTargetSelector}>
    <div class="hamburger-menu-area" on:click={onClickMenuBackground}
         class:show={isOpen}
    >
        <div class={menuAreaClass} style={menuAreaStyle}>
            <slot/>

            {#if menuRowTextArray != null}
                {#each menuRowTextArray as menuRowText}
                    <div class="row" on:click={()=>{
                            onClickRow(menuRowText);
                        }}>
                        { menuRowText }
                    </div>
                {/each}
            {/if}
        </div>

    </div>

</PortalView>

<style lang="scss">
    .hamburger-menu-view {

    }

    .hamburger-menu-area {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #0006;

        opacity: 0;
        pointer-events: none;

        &.show {
            opacity: 1;
            pointer-events: all;
        }

        .menu-area {
            position: fixed;
            background-color: var(--background-color);

            animation-duration: 0.5s;


            :global(.row) {
                padding-left: 2em;
                padding-right: 2em;
                padding-top: 0.5em;
                padding-bottom: 0.5em;

                &:nth-child(n + 2) {
                    border-top-style: solid;
                    border-color: #0003;
                    border-width: 1px;
                }
            }

        }
    }
</style>